import { createContextFactory } from '@streem/toolbox';
export const [CompanySettingsProvider, useCompanySettings] = createContextFactory('CompanySettings');
//# sourceMappingURL=company_settings.js.map